// React entry. Wraps the app in AuthKitProvider so any component can read
// the WorkOS session via useAuth(). redirectUri points back to /<origin>/
// after sign-in; the API's /auth/callback handles code exchange.
import React from 'react'
import ReactDOM from 'react-dom/client'
import { AuthKitProvider } from '@workos-inc/authkit-react'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'

const clientId = import.meta.env.VITE_WORKOS_CLIENT_ID as string
if (!clientId) console.warn('VITE_WORKOS_CLIENT_ID missing — auth flows will fail until set in apps/web/.env')

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthKitProvider clientId={clientId} redirectUri={`${window.location.origin}/`} devMode={import.meta.env.DEV}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthKitProvider>
  </React.StrictMode>,
)
